module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if(vues.length === 0) {;
__p += '\n   ' +
((__t = (noVuesMessage)) == null ? '' : __t) +
'\n';
};
__p += '\n';
_.each(vues,function(vue){;
__p += '\n<div class="DescartesBookmarks" id="' +
((__t = (vue.id)) == null ? '' : __t) +
'">\n    <label class="DescartesUILabel" title="' +
((__t = (vue.title)) == null ? '' : __t) +
'">' +
((__t = (vue.nom)) == null ? '' : __t) +
'&nbsp;:</label>\n    <button class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" title="' +
((__t = (reloadVue)) == null ? '' : __t) +
'">\n        <div class="DescartesBookmarksLoad"></div>\n    </button>\n    ';
if(vue.url!==null) {;
__p += '\n    <a class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" title="' +
((__t = (openVue)) == null ? '' : __t) +
'" href="' +
((__t = (vue.url)) == null ? '' : __t) +
'" target="_blank">\n        <div class="DescartesBookmarksOpen"></div>\n    </a>\n    ';
};
__p += '\n    <button class="btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" title="' +
((__t = (deleteVue)) == null ? '' : __t) +
'">\n        <div class="DescartesBookmarksRemove"></div>\n    </button>\n</div>\n';
});;
__p += '\n<hr/>\n<div>\n    <button id="' +
((__t = (id)) == null ? '' : __t) +
'_button" type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonMessage)) == null ? '' : __t) +
'</button>\n</div>\n\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/BookmarksInPlace.ejs
// module id = 390
// module chunks = 0